(function ($) {
  Drupal.behaviors.r4_night_routine = {
    attach: function (context) {
      $('#r4_mod5', context).once('r4_night_routine', function () {
        // Append the mpp container to the module
        $('#r4_mod5').parent().prev('.mpp.js-mpp-wrapper').appendTo('#r4_mod5_mpp');
      });

      // Append the Quick Shop buttons to their respective containers
      var qsBtnNo = $('.r4_mod5_qs a').length;

      function replaceQS(qsNo) {
        var target = $('#r4_mod5 #r4_mod5_mpp li.mpp__product:nth-of-type(' + qsNo + ') .product_brief__buttons-container .product_brief__panel .product_brief__buttons');
        var qsBtn = $('#r4_mod5_qs_' + qsNo);

        qsBtn.appendTo(target);
      }
      for (var i = 1; i <= qsBtnNo; i++) {
        replaceQS(i);
      }
    }
  };
})(jQuery);
